import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    error: null,
    providers: [],
    storageEndpoints: [],
};

const providerSlice = createSlice({
    name: 'providerSlice',
    initialState,
    reducers: {
        getProvidersRequest: (state) => {
            state.loading = true;
            state.error = null;
        },
        getProvidersSuccess: (state, action) => {
            state.providers = action.payload;
            state.loading = false;
            state.error = null;
        },
        getProvidersFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
        getStorageEndpointsRequest: (state) => {
            state.loading = true;
            state.error = null;
        },
        getStorageEndpointsSuccess: (state, action) => {
            state.storageEndpoints = action.payload;
            state.loading = false;
            state.error = null;
        },
        getStorageEndpointsFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        }
    },
});

export default providerSlice.reducer;

export const {
    getProvidersRequest,
    getProvidersSuccess,
    getProvidersFailure,
    getStorageEndpointsRequest,
    getStorageEndpointsSuccess,
    getStorageEndpointsFailure
} = providerSlice.actions;